import React from "react";
import {connect} from "react-redux";
import {ff} from "@mc/mc-legacy";
import RegistraceApi from "../../api/gen/core/RegistraceApi";
import AgreementCheckboxField from "../field/AgreementCheckboxField";
import {withLang} from "../../i18n/withLang";
import {Message} from "../../i18n/Message";
import {i18n} from "../../i18n/i18n";
import * as CustomModalActions from "../../actions/CustomModalActions";

class UserAgreementFormSection extends React.Component<any> {

    constructor(props: any, context: any) {
        super(props, context);
        this.state = {};
    }

    showAgreementREG_GDPR_UCET = () => {
        RegistraceApi.getTextSouhlasu("REG_GDPR_UCET").then((response) => {
          if (response) {
            if (response.url) {
              window.open(response.text, '_blank');
            } else {
              this.props.dispatch(
                CustomModalActions.showInfo(
                  i18n(this.props.lang, "UserAgreementFormSection_gdpr_detail"),
                  <div dangerouslySetInnerHTML={{ __html: response.text }} />,
                  null,
                  false,
                    false,
                  {},
                  // this.props.lang
                )
              );
            }
          }
        });
      };

      showAgreementREG_PODMINKY_PORTAL = () => {
        RegistraceApi.getTextSouhlasu("REG_PODMINKY_PORTAL").then((response) => {
          if (response) {
            if (response.url) {
              window.open(response.text, '_blank');
            } else {
              this.props.dispatch(
                CustomModalActions.showInfo(
                  i18n(this.props.lang, "UserAgreementFormSection_terms_detail"),
                  <div dangerouslySetInnerHTML={{ __html: response.text }} />,
                  null,
                  false,
                    false,
                  {},
                  // this.props.lang
                )
              );
            }
          }
        });
      };

    componentDidMount(): void {
        RegistraceApi.getConsentsUrl().then((res) => {
            this.setState({
                consentsUrl: res,
            });
        });
        RegistraceApi.getTextSouhlasu("REG_FORMULAR_SOUHLAS").then((response) => {
            if (response && response.text) {
                this.setState({
                    formularSouhlas: response.text,
                });
            }
        });
    }

    /**
     * Parsuje šablonu textu souhlasu a nahrazuje zástupné výrazy {osobniudaje:...} a {uzitiportalu:...} za klikací odkazy.
     */
    renderFormularSouhlas = (template: string) => {
        const parts: React.ReactNode[] = [];
        const regex = /\{(osobniudaje|uzitiportalu)\s*:\s*([^}]+)\}/g;
        let lastIndex = 0;
        let match;

        while ((match = regex.exec(template)) !== null) {
            // Text před zástupným výrazem
            if (match.index > lastIndex) {
                parts.push(template.substring(lastIndex, match.index));
            }

            const key = match[1];
            const linkText = match[2].trim();

            if (key === 'osobniudaje') {
                parts.push(
                    <a href="#" className={"btn-link-main"} key={`osobniudaje-${match.index}`}
                       onClick={this.showAgreementREG_GDPR_UCET}>
                        {linkText}
                    </a>
                );
            } else if (key === 'uzitiportalu') {
                parts.push(
                    <a href="#" className={"btn-link-main"} key={`uzitiportalu-${match.index}`}
                       onClick={this.showAgreementREG_PODMINKY_PORTAL}>
                        {linkText}
                    </a>
                );
            }

            lastIndex = match.index + match[0].length;
        }

        // Zbývající text za posledním zástupným výrazem
        if (lastIndex < template.length) {
            parts.push(template.substring(lastIndex));
        }

        return parts;
    };

  render() {
    const { consentsUrl, formularSouhlas } = this.state;

    return (
      <ff.Base
        className={"user-agreement-form-section"}
        componentClass={AgreementCheckboxField}
        name={"agreement"}
        label={false}
        disabled={this.props.submitting}
        required
        componentLabel={
          <div className={"btn-link-main"}>
              {consentsUrl ?
                  <Message
                      lang={this.props.lang}
                      langKey={"UserAgreementFormSection_agreement2"}
                      getArg={(index) => {
                          switch (index) {
                              case 1:
                                  return (
                                      <a href={(window as any).appConfig.serverContextPath + "/redirect/consents"} target="_blank" className={"btn-link-main"}>
                                          {i18n(this.props.lang, "UserAgreementFormSection_gdpr_and_terms")}
                                      </a>
                                  );
                          }
                      }}
                  />
                  : formularSouhlas
                  ? <span>{this.renderFormularSouhlas(formularSouhlas)}</span>
                  :
                  <Message
                      lang={this.props.lang}
                      langKey={"UserAgreementFormSection_agreement"}
                      getArg={(index) => {
                          switch (index) {
                              case 1:
                                  return (
                                      <a href="#" className={"btn-link-main"} key={1}
                                         onClick={this.showAgreementREG_GDPR_UCET}>
                                          {i18n(this.props.lang, "UserAgreementFormSection_gdpr")}
                                      </a>
                                  );

                              case 2:
                                  return (
                                      <a href="#" className={"btn-link-main"} key={2}
                                         onClick={this.showAgreementREG_PODMINKY_PORTAL}>
                                          {i18n(this.props.lang, "UserAgreementFormSection_terms")}
                                      </a>
                                  );
                          }
                      }}
                  />
              }
          </div>
        }
      />
    );
  }
}

export default withLang(connect()(UserAgreementFormSection));
